import React from 'react';
import TasksDetailPage from '../components/TasksDetailPage';

const TasksDetailApp = (props) => (
  <TasksDetailPage {...props} />
);

export default TasksDetailApp;
